import StampCompose from "./StampCompose";

export default StampCompose;
